import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Dash from "../../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Bezugsschlankheitsgrad({ bezugsschlankheitsgrad }) {
  const { t } = useTranslation("translation");
  const BezugsschlankheitsgradFormula = `\\displaystyle \\lambda_{1} = \\pi \\cdot \\sqrt{\\frac{E}{f_{y,k}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.referencedSlendernessRatio")}</p>}
      formulaValue={
        <ToolTip
          id={"BezugsschlankheitsgradFormula"}
          type={IconType.FORMULA}
          formula={BezugsschlankheitsgradFormula}
        />
      }
      indicesValue={
        <span>
          &lambda;<sub>1</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(bezugsschlankheitsgrad, 2)}</span>}
      unitValue={<Dash />}
    />
  );
}

export default Bezugsschlankheitsgrad;
